export { saveAs } from './save-as';
export { encodeBase64 } from './base64';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-file-saver/dist/es/main.js
// module id = 1667
// module chunks = 0